import { render, staticRenderFns } from "./DiseaseCategoryChip.vue?vue&type=template&id=3cfe87c9&scoped=true&"
import script from "./DiseaseCategoryChip.vue?vue&type=script&lang=js&"
export * from "./DiseaseCategoryChip.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseCategoryChip.vue?vue&type=style&index=0&id=3cfe87c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe87c9",
  null
  
)

export default component.exports